import { CORE_USER, GENERAL_USER, TPO_ADMIN } from "./Constants";

export const StatusColors = {
  Uploaded: '#FFECBB',
  Initiated: '#FFECBB',
  Completed: '#B3DACB',
  Success: '#B3DACB',
  Processing: '#FFECBB',
  Uploading: '#FFECBB',
  Created: '#FFECBB',
  Updated: '#AAD2E2',
  Failed: '#F6CCD2',
  Deleted: '#818181',
  Locked: '#DFDFDF',
  'In Progress': '#FFDCBB',
  InProgress: '#FFDCBB',
  Submitted: '#FFECBB'
};


// Table to disable features on the basis of user role
export const MarketRoleAccess = {
  // us: {
  [TPO_ADMIN]: {
    pages: { '/alignment-action/feedback-collation': { 'multi-vote': true } }
  },
  [CORE_USER]: {
    pages: {
      '/alignment-action/feedback-collation': { 'multi-vote': true },
      '/alignment-action/decision-making-central': { 'multi-vote': false }
    }
  },
  [GENERAL_USER]: {
    pages: {
      '/portfolio/master-data': { 'bulk-upload': true }, // true for disabling this feature,
      '/home': { 'banner-tpo-lead': true },
      '/alignment-action/decision-making-central': { 'multi-vote': true }
      // hide for functional and regional- voting card, save-filter and drawer 'typo-vote': true,'reco-select': true,'comment-vote':true
      // '/alignment-action/feedback-collation':{'save-filter': true, 'multi-vote': true},
    }
  },
  'Functional': {
    pages: {
      '/alignment-action/feedback-collation': { 'multi-vote': true },
    }
  },
  'Regional': {
    pages: {
      '/alignment-action/feedback-collation': { 'multi-vote': true },
    }
  }
};

export const chartConfig = {
  mode: 'index',  // Show tooltip when hovering anywhere in the column
  axis: 'x',      // Trigger tooltip based on x-axis hover
  intersect: false // Ensures it works for the full column
}
